var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": _vm.dialogWidth
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "id": "add-table",
            "color": "blue darken-2",
            "icon": "",
            "medium": "",
            "disabled": !_vm.userCanEdit
          }
        }, on), [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v(" mdi-plus-circle ")])], 1)];
      }
    }]),
    model: {
      value: _vm.tableDialog,
      callback: function callback($$v) {
        _vm.tableDialog = $$v;
      },
      expression: "tableDialog"
    }
  }, [_c('v-stepper', {
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1"
    }
  }, [_vm._v(" Select Dataset ")]), _c('v-divider'), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 2,
      "step": "2",
      "rules": [function () {
        return _vm.tableCreationError === null;
      }]
    }
  }, [_vm._v(" Set Column Types "), _c('small', [_vm._v(_vm._s(_vm.tableCreationError))])])], 1), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', [_c('v-card', [_c('v-card-text', {
    staticClass: "px-4 pt-4 pb-1"
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-file-input', {
    attrs: {
      "label": "Upload File",
      "prepend-inner-icon": "mdi-paperclip",
      "prepend-icon": "",
      "single-line": "",
      "clearable": "",
      "dense": "",
      "outlined": "",
      "show-size": "",
      "accept": ".csv"
    },
    model: {
      value: _vm.selectedFile,
      callback: function callback($$v) {
        _vm.selectedFile = $$v;
      },
      expression: "selectedFile"
    }
  })], 1)], 1), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Table Name",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.fileName,
      callback: function callback($$v) {
        _vm.fileName = $$v;
      },
      expression: "fileName"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', {
    staticClass: "px-4 py-3"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "disabled": _vm.createDisabled,
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.step = 2;
      }
    }
  }, [_vm._v(" Next ")])], 1), _vm.uploading ? _c('v-progress-linear', {
    attrs: {
      "value": _vm.uploadProgress
    }
  }) : _vm._e()], 1)], 1)], 1), _c('v-stepper-content', {
    staticClass: "pa-0",
    attrs: {
      "step": "2"
    }
  }, [_c('v-data-table', {
    staticClass: "upload-preview",
    attrs: {
      "fixed-header": "",
      "headers": _vm.headers,
      "hide-default-header": "",
      "items": _vm.sampleRows,
      "height": "65vh"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref2) {
        var innerHeaders = _ref2.props.headers;
        return [_c('thead', {
          attrs: {
            "dark": ""
          }
        }, [_c('tr', _vm._l(innerHeaders, function (header, i) {
          return _c('th', {
            key: i,
            staticClass: "pt-2 pb-4"
          }, [_vm._v(" " + _vm._s(header.text) + " "), _c('v-select', {
            attrs: {
              "outlined": "",
              "dark": "",
              "dense": "",
              "hide-details": "",
              "items": _vm.multinetTypes
            },
            model: {
              value: _vm.columnType[header.text],
              callback: function callback($$v) {
                _vm.$set(_vm.columnType, header.text, $$v);
              },
              expression: "columnType[header.text]"
            }
          })], 1);
        }), 0)])];
      }
    }])
  }), _c('v-footer', {
    staticClass: "py-3"
  }, [_c('v-select', {
    staticClass: "mr-2",
    staticStyle: {
      "max-width": "100px"
    },
    attrs: {
      "items": _vm.delimiterOptions,
      "persistent-hint": "",
      "hint": "Delimiter"
    },
    on: {
      "change": _vm.delimiterQuoteChanged
    },
    model: {
      value: _vm.delimiter,
      callback: function callback($$v) {
        _vm.delimiter = $$v;
      },
      expression: "delimiter"
    }
  }), _c('v-select', {
    staticStyle: {
      "max-width": "100px"
    },
    attrs: {
      "items": _vm.quoteCharOptions,
      "persistent-hint": "",
      "hint": "Quote Character"
    },
    on: {
      "change": _vm.delimiterQuoteChanged
    },
    model: {
      value: _vm.quoteChar,
      callback: function callback($$v) {
        _vm.quoteChar = $$v;
      },
      expression: "quoteChar"
    }
  }), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.step = 1;
      }
    }
  }, [_vm._v(" Back ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": "",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.createTable
    }
  }, [_vm._v(" Create Table ")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }